// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e4a3ccb0","732":"ab2f3d66","977":"de6ca1df"}[chunkId] + ".chunk.js";
};